import React from "react";
import "../../styles/Project.css";
import { TagColors } from "../../data/general";
const TagCheckbox = ({
  title,
  id,
  lblClass = "h-7 xl:h-8 ",
  containerClass = "",
  checked,
  onChange,
  index,
}) => {
  const { secondColor } = TagColors[index] ?? {};

  return (
    <div className={`${containerClass} `}>
      <input
        type="checkbox"
        id={id}
        className="appearance-none hidden h-full  "
        onChange={onChange}
        checked={checked}
      />
      <label
        style={{ backgroundColor: checked ? secondColor : "#dfe1e2" }}
        htmlFor={id}
        className={`flex items-center font-medium
              ${lblClass} bg-transparent cursor-pointer transition-all duration-300 rounded-2xl overflow-hidden px-3 text-custom-gray-900`}
      >
        <span className="text-sm">{title}</span>
      </label>
    </div>
  );
};

export default TagCheckbox;
